export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, UsersResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
        this.searchText = '';
    }

    search() {

        this.spAlert = null;
        this.selectedCompanyUser = null;

        if (this.searchText === this.account.companyUser.saaspassUser.saaspassId) {
            this.Alert('danger', 'company.user-directories.manage-account.owner.same-user', false);
            return;
        }

        if (this.searchText === this.account.emailAddress) {
            this.Alert('danger', 'company.user-directories.manage-account.owner.same-email', false);
            return;
        }

        this.isSearching = true;

        this.UsersResource
            .getCompanyUserForSaaspassUser(this.companyId,this.searchText)
            .then((companyUser) => {
                if (
                    companyUser.id === this.account.companyUser.id ||
                    companyUser.saaspassUser.id === this.account.companyUser.saaspassUser.id
                ) {
                    this.Alert('danger', 'company.user-directories.manage-account.owner.same-user', false);
                } else {
                    this.selectedCompanyUser = companyUser;
                }
            })
            .catch((response) => {
                if (response.status === 404) {
                    this.Alert('danger', 'company.user-directories.manage-account.owner.user-not-found', false);
                }
            })
            .finally(() => this.isSearching = false);
    }

    showChangeModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageAccountChangeOwnerConfirm',
                resolve: {
                    accountId: () => this.account.id,
                    companyId: () => this.companyId,
                    newOwner: () => this.selectedCompanyUser,
                },
            }).result
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.owner.change.success'))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/manage-account-owner.controller.js